/**
 * Main Application - Component Definition
 *
 * @export
 * @class App
 * @implements {ng.IComponentOptions}
 */
export class App implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: ng.IControllerConstructor = AppController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./app.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {}

  // public $routeConfig: any = [
  //   {path: '/', name: 'Home', component: 'home', useAsDefault: true},
  //   {path: '/**', name: 'NotFound', component: 'notFound' }
  // ]
}

/**
 * App - Controller
 *
 * @export
 * @class AppController
 */
export class AppController {

  /**
   * $inject to make angular DI minifiication safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', '$location']
  public path
  public configFileUrl

  /**
   * @param {*} $log Angular Log Service
   * @param {*} angularServices Angular Services Convenience Service
   * @param {*} appServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public $location: any) {
    this.$log = $log.getInstance('AppController', false)
    this.$log.debug('constructor')

    // this.$analytics.pageTrack('/home');
    // this.$analytics.eventTrack('testEvent');
  }

  /**
   * life cycle hooks
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')

    //disable pointer-events on touch devices so we don't get :hover effects, etc
    if (this.AppServices.UserAgentManager.isMobile() || this.AppServices.UserAgentManager.isTablet()) {
      this.AngularServices.$animate.addClass(this.$element, 'isTouch')
    }
    /*if (document.referrer === 'http://localhost:8000/'){  // We have to change the referer for the one Marvel Provides.*/
      this.AppServices.DataManager.load().then(config => {

        if (!this.AppServices.DevTools.isDevelopmentEnvironment()) {
          this.path = this.$location.absUrl();
          this.configFileUrl = this.path.replace("index.html", "");
          let position = this.configFileUrl.indexOf('?');
          if (position !== -1){
            config.settings.assetsPath = this.configFileUrl.substr(0, position) + config.settings.assetsPath
            config.settings.audio.audioAssetsPath = this.configFileUrl.substr(0, position) + config.settings.audio.audioAssetsPath
          } else{
            config.settings.assetsPath = this.configFileUrl + config.settings.assetsPath
            config.settings.audio.audioAssetsPath = this.configFileUrl + config.settings.audio.audioAssetsPath
          }
          // redspace
          // config.settings.assetsPath = "/hero-creator" + config.settings.assetsPath
          // config.settings.audio.audioAssetsPath = "/hero-creator" + config.settings.audio.audioAssetsPath

          // marvel
          // config.settings.assetsPath = "/u/stage/games/marvelkids/mk_buildyourown_4/" + config.settings.assetsPath
          // config.settings.audio.audioAssetsPath = "/u/stage/games/marvelkids/mk_buildyourown_4/" + config.settings.audio.audioAssetsPath

          // marvel international
          // config.settings.assetsPath = "http://img.lum.dolimg.com/v1/files/23877400-54cc-11e6-b810-067c180000f7" + config.settings.assetsPath
          // config.settings.audio.audioAssetsPath = "http://img.lum.dolimg.com/v1/files/23877400-54cc-11e6-b810-067c180000f7" + config.settings.audio.audioAssetsPath
        }
        this.AppServices.ScreenManager.init(config)
        this.AppServices.AudioManager.init(config)
        this.AppServices.ColorManager.init(config)
        this.AppServices.DataManager.loadLanguage();
      })
    /* } */
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj: any): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/app.ts
 **/